module.exports = __webpack_public_path__ + "img/Logo-white.956a68cd.png";